import React, {useRef, useEffect} from 'react';
import {Box, Typography} from '@customink/pigment-react';
import useBreakpoint from '../hooks/useBreakpoint';
import desktopPromoImage from 'images/desktop-drinkware-promo.png';
import mobilePromoImage from 'images/mobile-drinkware-promo.png';
import config from '../config';

export const PromoBanner = ({page, analyticsAttributes}) => {
  const breakpoint = useBreakpoint();
  const isSubcat = page === 'subcat';
  const isMobile =
    breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md';
  const fireAnalytics = useRef(false);

  const fontSize = isMobile ? '1rem' : isSubcat ? '1.75rem' : '1.25rem';
  const marginBottom = isSubcat ? '1rem' : isMobile ? '0.5rem' : '1rem';
  const marginTop = isSubcat ? '0.375rem' : isMobile ? '0.5rem' : '1.75rem';
  // until we have fixed webpack configuration
  const imagePath = config.assets.imagePath;

  useEffect(() => {
    if (!fireAnalytics.current) {
      window.dataLayer.push({
        event: 'view_promotion',
        ecommerce: {
          creative_name: analyticsAttributes?.creative_name,
          creative_slot: isSubcat ? 'Category Page Banner' : 'PLP Banner',
          promotion_id: analyticsAttributes?.id,
          promotion_name: 'May 2025 Drinkware Promo'
        }
      });
      fireAnalytics.current = true;
    }
  }, []);

  return (
    <Box
      display="flex"
      overflow="hidden"
      borderRadius="0.5rem"
      marginTop={marginTop}
      marginBottom={marginBottom}>
      <img
        src={
          isMobile
            ? `${imagePath}${mobilePromoImage}`
            : `${imagePath}${desktopPromoImage}`
        }
        alt="Promo Banner"
        className="desktop-promo"
      />
      <Box
        backgroundColor="#A639B2"
        padding="1.5rem"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%">
        <Typography
          color="white"
          textAlign={isMobile ? 'left' : 'center'}
          fontSize={fontSize}
          fontWeight="700"
          lineHeight="125%"
          width={isSubcat && !isMobile ? '75%' : '100%'}
          fontFamily="SharpSans">
          Save 20% off drinkware-prices as marked. Offer ends May 26.*
        </Typography>
      </Box>
    </Box>
  );
};
